import { render, staticRenderFns } from "./add_account.vue?vue&type=template&id=63f9a0a9&scoped=true&"
import script from "./add_account.vue?vue&type=script&lang=js&"
export * from "./add_account.vue?vue&type=script&lang=js&"
import style0 from "./add_account.vue?vue&type=style&index=0&id=63f9a0a9&lang=scss&scoped=true&"
import style1 from "./add_account.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9a0a9",
  null
  
)

export default component.exports